// Google Cloud Storage Base URL
export const GCS_BASE_URL = "https://storage.googleapis.com/my_healing";

// Current number of videos (1.mp4 to 10.mp4)
export const VIDEO_COUNT = 10;

export const HEALING_FILE_NAMES = Array.from(
  { length: VIDEO_COUNT },
  (_, i) => `${i + 1}.mp4`
);

